import React from "react";
import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Line-by-line masked reveal for headlines
export function MaskLines({ lines, className = "", stagger = 0.12, delay = 0.1 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} style={{ display: "block", overflow: "hidden" }}>
          <motion.span
            style={{ display: "block", willChange: "transform" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, delay: delay + i * stagger, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function TechLabel({ children, className = "", color = "#A8895D" }) {
  return (
    <span className={`tech-label inline-flex items-center gap-2 flex-wrap max-w-full ${className}`} style={{ color }}>
      <span style={{ width: 22, height: 1, background: color, display: "inline-block", flexShrink: 0 }} />
      <span className="min-w-0 break-words">{children}</span>
    </span>
  );
}
